import type { UseFormReturn } from "react-hook-form";
import SelectGitStorageDataFields from "../../git/actions/Source/Git/components/SelectGitStorageDataFields";
import SelectGiteaStorageDataFields from "../../git/actions/Source/Gitea/components/SelectGiteaStorageDataFields";
import type GiteaSourceData from "../../git/actions/Source/Gitea/logic/GiteaSourceData";
import SelectGitHubStorageDataFields from "../../git/actions/Source/GitHub/components/SelectGitHubStorageDataFields";
import type GitHubSourceData from "../../git/actions/Source/GitHub/logic/GitHubSourceData";
import SelectGitLabStorageDataFields from "../../git/actions/Source/GitLab/components/SelectGitLabStorageDataFields";
import type GitlabSourceData from "../../git/actions/Source/GitLab/logic/GitlabSourceData";
import SelectGitVerseStorageDataFields from "../../git/actions/Source/GitVerse/components/SelectGitVerseStorageDataFields";
import type GitVerseSourceData from "../../git/actions/Source/GitVerse/logic/GitVerseSourceData";
import type GitSourceData from "../../git/core/model/GitSourceData.schema";
import type { SelectFormSchemaType } from "../logic/SourceDataProvider/model/SelectSourceFormSchema";
import type SourceData from "../logic/SourceDataProvider/model/SourceData";
import SourceType from "../logic/SourceDataProvider/model/SourceType";

interface SelectRepoFromStorageFieldsProps {
	form: UseFormReturn<SelectFormSchemaType>;
	sourceData: SourceData;
	mode?: "init" | "clone";
}

export const SelectRepoFromStorageFields = (props: SelectRepoFromStorageFieldsProps) => {
	const { form, sourceData, mode } = props;

	return (
		<>
			{sourceData?.sourceType === SourceType.git && (
				<SelectGitStorageDataFields form={form} mode={mode} source={sourceData as GitSourceData} />
			)}
			{sourceData?.sourceType === SourceType.gitLab && (
				<SelectGitLabStorageDataFields form={form} mode={mode} source={sourceData as GitlabSourceData} />
			)}
			{sourceData?.sourceType === SourceType.gitHub && (
				<SelectGitHubStorageDataFields form={form} mode={mode} source={sourceData as GitHubSourceData} />
			)}
			{sourceData?.sourceType === SourceType.gitVerse && (
				<SelectGitVerseStorageDataFields form={form} mode={mode} source={sourceData as GitVerseSourceData} />
			)}
			{sourceData?.sourceType === SourceType.gitea && (
				<SelectGiteaStorageDataFields form={form} mode={mode} source={sourceData as GiteaSourceData} />
			)}
		</>
	);
};
